import { Check } from "lucide-react-native";
import {
  Checkbox,
  CheckboxIcon,
  CheckboxIndicator,
  CheckboxLabel,
} from "../../../../../ui/checkbox";
import type { FieldControlProps } from "../fieldTypes";

/** The label lives on the checkbox itself, so `FormField` does not draw a second one. */
const ToggleField = ({
  field,
  value,
  onChange,
  disabled,
}: FieldControlProps) => (
  <Checkbox
    size="md"
    action="brand"
    value={field.key}
    isChecked={value === true}
    isDisabled={disabled}
    onChange={onChange}
    accessibilityLabel={field.label}
    className="min-h-11"
  >
    <CheckboxIndicator>
      <CheckboxIcon as={Check} />
    </CheckboxIndicator>
    <CheckboxLabel>{field.label}</CheckboxLabel>
  </Checkbox>
);

export default ToggleField;
